import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_LIST_API_ID = 'DASHBOARD/FETCH_STOCK_LIST_API_ID';

const apiCall = createApiCall(FETCH_STOCK_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stocks`,
    params: {
      type: 'stock',
      ...((params as unknown) as Record<string, any>),
    },
  }),
  method: 'GET',
}));

export default apiCall;
